// src/Korean.js
import React from 'react';
import './KoreanActivity.css';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Translation data
const stances = [
  ['Gunnun', 'Walking'], ['Annun', 'Sitting'], ['Niunja', 'L-stance'],
  ['Narani', 'Parallel'], ['Charyot', 'Attention'], ['Gojung', 'Fixed'],
  ['Moa Junbi', 'Closed'], ['Goburyo', 'Bending'], ['Kyocha', 'X-stance'],
  ['Nachou', 'Low'], ['Dwitbal', 'Rear Foot'], ['Soojik', 'Vertical'], ['Waebal', 'One-Leg'],
  ['Sasun', 'Diagonal']
];

const techniques = [
  ['Jirugi', 'Punch'], ['Tulgi', 'Thrust'], ['Taerigi', 'Strike'], ['Makgi', 'Block'], ['Golcha', 'Hooking'], ['Miro', 'Pushing'],
  ['',''],
  ['Yop Cha Jirugi', 'Piercing Kick'], ['Cha Busigi', 'Snap Kick'], ['Cha Olligi','Rising Kick'], ['Twimyo Chagi', 'Flying Kick'], ['Dwitcha Jirugi', 'Back Piercing Kick'],
  ['Bituro Chagi', 'Twisting Kick'], ['Suroh Chagi', 'Sweeping Kick'], ['Yopcha Tulgi', 'Thrusting Kick'], ['Nopi Chagi', 'High Kick'], ['Milgi Chagi', 'Pushing Kick'], ['Momchoogi', 'Checking Kick'], ['Golcho Chagi','Hooking Kick'],
  ['',''],
  ['Doo', 'Double'], ['Noollo', 'Pressing'],
  ['Sang', 'Twin'], ['Daebi', 'Guarding'], ['Hechyo', 'Wedging'], ['Ollyo', 'Upward'],
  ['Annuro', 'Inward'], ['Naeryo', 'Downward'], ['Bakuro', 'Outwards'], ['Dwijibo', 'Upset'], ['Sewo', 'Vertical'],
  ['Chookyo', 'Rising'], ['Wi', 'Upper'], ['Dollimyo', 'Circular'], ['Twigi', 'Jumping'],
  ['Duro', 'Scooping'], ['Soopyong', 'Horizontal'],
  ['',''],
  ['Ap', 'Front'], ['Yop', 'Side'], ['Dung', 'Back'], ['Yopap', 'Side Front']
];

const numbers = [
  ['Hana', 'One'], ['Dool', 'Two'], ['Set', 'Three'], ['Net', 'Four'], ['Tasut', 'Five'],
  ['Yasut', 'Six'], ['Ilgot', 'Seven'], ['Yodul', 'Eight'], ['Ahop', 'Nine'], ['Yol', 'Ten']
];

const others = [
  ['Dwijibun Sonkut', 'Upset Fingertips'], ['Opun Sonkut', 'Flat Fingertips'], ['Sun Sonkut', 'Straight Fingertips'], ['Homi Sonkut','Angle Fingertips'],
  ['',''],
  ['Giokja Jirugi', 'Angle Punch'], ['Dollyo Jirugi', 'Turning Punch'], ['Bandal Jirugi', 'Crescent Punch'],
  ['',''],
  ['Digutja Makgi', 'U-shaped Block'], ['San Makgi', 'W-shaped Block'], ['Momchau Makgi', 'Checking Block'], ['Gutja Makgi', '9-Shape Block'], ['Hori Makgi', 'Waist Block'],
  ['',''],
  ['Hanulson', 'Heaven Hand'], ['Bandalson', 'Arc Hand'], ['Bakuro Gutgi', 'Outwards Cross Cut'], ['Jap Sol Tae', 'Releasing Movement'], ['Ghin Joomuk', 'Long Fist'], ['Mit Joomuk','Under Fist'], ['Sonmokdung','Bow Wrist'], ['Songarak Joomuk','Knuckle Fist'],
  ['',''],
  ['Baro', 'Obverse'], ['Bandae', 'Reverse'], ['Oran', 'Right'], ['Wen', 'Left'], 
  ['',''],
  ['Junbi', 'Ready'], ['Si-jak', 'Start'], ['Guman', 'Stop'], ['Pharo', 'Return'], ['Hae San', 'Dismissed'], ['Dojang', 'Training Hall']
];

const Korean = () => {
  const navigate = useNavigate();

  const handleMatchClick = () => {
    navigate('/korean-match');
  };

  return (
    <>
      <Helmet>
        <title>TKD Study - Korean</title>
      </Helmet>
      <div className="korean-activity">
        <div className="korean-container">
          <h1>Korean</h1>
          <button className="match-button" onClick={handleMatchClick}>
            Match!
          </button>
          <div className="back-arrow" onClick={() => navigate('/')}>
            ← Back
          </div>
          <Section title="Stances" koreanTitle="Sogi">
            <TranslationTable rows={stances} />
          </Section>
          <Section title="Techniques" koreanTitle="Gibeob">
            <TranslationTable rows={techniques} />
          </Section>
          <Section title="Numbers" koreanTitle="Susja">
            <TranslationTable rows={numbers} />
          </Section>
          <Section title="Others" koreanTitle="Gita">
            <TranslationTable rows={others} />
          </Section>
        </div>
      </div>
    </>
  );
};

const Section = ({ title, koreanTitle, children }) => (
  <div className="section">
    <h2>{title} / <span className="korean">{koreanTitle}</span></h2>
    {children}
  </div>
);

const TranslationTable = ({ rows }) => (
  <div className="translation-table">
    <div className="table-row table-header">
      <div>Korean</div>
      <div>English</div>
    </div>
    {rows.map(([kor, eng], idx) => (
      <div className="table-row" key={idx}>
        <div>{kor}</div>
        <div>{eng}</div>
      </div>
    ))}
  </div>
);

export default Korean;
